module.exports = __webpack_public_path__ + "static/media/house2.8f288dfd.webp";